import React, { useEffect } from 'react'

import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import Form from 'modules/processes/components/ItemWizard/components/Form'
import Assignees from 'modules/processes/components/ItemWizard/components/Form/Items/Assignees'
import Attachments from 'modules/processes/components/ItemWizard/components/Form/Items/Attachment'
import Deadline from 'modules/processes/components/ItemWizard/components/Form/Items/Deadline'
import Description from 'modules/processes/components/ItemWizard/components/Form/Items/Description'
import FolderSelector from 'modules/processes/components/ItemWizard/components/Form/Items/FolderSelector'
import Mandatory from 'modules/processes/components/ItemWizard/components/Form/Items/Mandatory'
import Title from 'modules/processes/components/ItemWizard/components/Form/Items/Title'

const Content = () => {
  const { form, initializeForm } = useFormProvider()

  useEffect(() => {
    initializeForm(TaskConfigurationTypes.UploadDocument)
  }, [])

  if (!form) return null

  return (
    <Form
      items={{
        title: <Title />,
        assignees: <Assignees />,
        folder: <FolderSelector />,
        description: <Description />,
        deadline: <Deadline />,
        attachments: <Attachments />,
        mandatory: <Mandatory />,
      }}
    />
  )
}

export default Content
